import { createContext, useContext } from 'react';
import { SdkCodeSnippetsAsyncProps } from '@cld/sdk-code-snippets';

export interface RecipeContentContextType {
  languageChangeCallback?: SdkCodeSnippetsAsyncProps['onSnippetChange'];
  copyCallback?: SdkCodeSnippetsAsyncProps['onCopy'];
}
export const RecipeContentContext = createContext<RecipeContentContextType | undefined>(undefined);
export const useRecipeContentContext = () => {
  const context = useContext(RecipeContentContext);
  if (context === undefined) {
    throw new Error('No RecipeContentContext provided');
  }
  return context;
};
export const RecipeContentProvider = RecipeContentContext.Provider;
